export const checkoutLayouts = {
  CENTER: 'center',
  SPLIT: 'split',
  DOUBLE: 'double',
  DOUBLE_BANNER: 'double_banner',
};
